<template>
	<div>
		<div class="sv-tabs horizontal-center bold18 mb-20">
			<div class="sv-tab text-center" @click="isTeam = false">
				個人
				<hr class="sv-tab-underline" :style="{ 'visibility': isMemberTabUnderlineVisible }"/>
			</div>

			<div class="sv-tab" @click="isTeam = true">
				チーム
				<hr class="sv-tab-underline" :style="{ 'visibility': isTeamTabUnderlineVisible }"/>
			</div>
		</div>

		<div class="mb-40 tm" style="font-size: 18px">条件を選択してください。</div>

		<div v-show="!isTeam" class="tab-contents">
			<div class="input-wrap">
				<div class="input-title">ランキング種別</div>
				<div class="sv-field">
					<b-select v-model="staffCoinId">
						<option value="">総合</option>
						<option
							v-for="row in coins"
							:value="row.id"
							:key="row.id">
							{{ row.name }}コイン
						</option>
					</b-select>
				</div>
			</div>

			<summary-period-select :dateProvided="dateProvided" @period-change="onStaffSummaryPeriodChange" @end-change="onStaffSummaryPeriodEndChange" @start-change="onStaffSummaryPeriodStartChange"></summary-period-select>

			<b-button type="is-success" class="max-w-button mt-30 mb-50" :loading="isStaffRankingSearchLoading" @click="onStaffRankingSearchButtonClick">表示する</b-button>

			<div class="tab-header horizontal-center">
				<div class="recieve bold18 text-center" @click="isStaffRankingRecieve = true; isStaffRankingPresent = false">獲得</div>
				<div class="present bold18 text-center" @click="isStaffRankingRecieve = false; isStaffRankingPresent = true">贈呈</div>
			</div>

			<div class="ranking-wrap">
				<div v-show="isStaffRankingRecieve" class="ranking recieve">
					<div class="ranking-title-pc text-center">獲得</div>

					<div class="period text-center mb-15">{{ staffPeriodText }}</div>

					<div v-if="staffRecieveRankings.length > 0">
						<div class="mb-10 member-list-item-wrap" v-for="(row, index) in staffRecieveRankings" :key="index">
							<member-list-item
								v-show="index < initialMaxShow || isStaffRankingRecieveMore"
								class="member-list-item"
								:image="row.image"
								:name="row.name"
								:staffId="row.id"
								:isRightNoPadding="true"
								>

								<div class="count-wrap horizontal-center-center">
									<div>
										<div class="text-center">獲得コイン数</div>
										<div class="text-center"><span class="count">{{ row.count }}</span><span class="bold18">枚</span></div>
									</div>
								</div>
					
							</member-list-item>

							<div v-show="index < initialMaxShow || isStaffRankingRecieveMore" class="ranking-crown-wrap">
								<div class="ranking-crown text-center">
									<img :src="require('@/assets/icons/ranking_crown.svg')"/>
									<span>{{ row.rank }}</span>
								</div>
							</div>
						</div>
				
						<div class="text-center mt-20">
							<b-button type="is-more" rounded @click="isStaffRankingRecieveMore = true" v-show="!isStaffRankingRecieveMore && staffRecieveRankings.length > initialMaxShow">＋もっと見る</b-button>
						</div>
					</div>
					<div v-else style="color: #fff">データはありません</div>
				</div>

				<div v-show="isStaffRankingPresent" class="ranking present">
					<div class="ranking-title-pc text-center">贈呈</div>

					<div class="period text-center mb-15">{{ staffPeriodText }}</div>

					<div v-if="staffPresentRankings.length > 0">
						<div class="mb-10 member-list-item-wrap" v-for="(row, index) in staffPresentRankings" :key="index">
							<member-list-item
								v-show="index < initialMaxShow || isStaffRankingPresentMore"
								class="member-list-item"
								:image="row.image"
								:name="row.name"
								:staffId="row.id"
								:isRightNoPadding="true"
								>

								<div class="count-wrap horizontal-center-center">
									<div>
										<div class="text-center">贈呈コイン数</div>
										<div class="text-center"><span class="count">{{ row.count }}</span><span class="bold18">枚</span></div>
									</div>
								</div>
					
							</member-list-item>

							<div v-show="index < initialMaxShow || isStaffRankingPresentMore" class="ranking-crown-wrap">
								<div class="ranking-crown text-center">
									<img :src="require('@/assets/icons/ranking_crown.svg')"/>
									<span>{{ row.rank }}</span>
								</div>
							</div>
						</div>
				
						<div class="text-center mt-20">
							<b-button type="is-more" rounded @click="isStaffRankingPresentMore = true" v-show="!isStaffRankingPresentMore && staffPresentRankings.length > initialMaxShow">＋もっと見る</b-button>
						</div>
					</div>
					<div v-else style="color: #fff">データはありません</div>
				</div>

			</div>

		</div>

		<div v-show="isTeam" class="tab-contents">
			<div class="input-wrap">
				<div class="input-title">ランキング種別</div>
				<div class="sv-field">
					<b-select v-model="teamCoinId">
						<option value="">総合</option>
						<option
							v-for="row in coins"
							:value="row.id"
							:key="row.id">
							{{ row.name }}コイン
						</option>
					</b-select>
				</div>
			</div>

			<summary-period-select :dateProvided="dateProvided" @period-change="onTeamSummaryPeriodChange" @end-change="onTeamSummaryPeriodEndChange" @start-change="onTeamSummaryPeriodStartChange"></summary-period-select>

			<b-button type="is-success" class="max-w-button mt-30 mb-50" :loading="isTeamRankingSearchLoading" @click="onTeamRankingSearchButtonClick">表示する</b-button>

			<div class="tab-header horizontal-center">
				<div class="recieve bold18 text-center" @click="isTeamRankingRecieve = true; isTeamRankingPresent = false">獲得</div>
				<div class="present bold18 text-center" @click="isTeamRankingRecieve = false; isTeamRankingPresent = true">贈呈</div>
			</div>

			<div class="ranking-wrap">
				<div v-show="isTeamRankingRecieve" class="ranking recieve">
					<div class="ranking-title-pc text-center">獲得</div>

					<div class="period text-center mb-15">{{ teamPeriodText }}</div>

					<div v-if="teamRecieveRankings.length > 0">
						<div class="mb-10 member-list-item-wrap" v-for="(row, index) in teamRecieveRankings" :key="index">
							<member-list-item
								v-show="index < initialMaxShow || isTeamRankingRecieveMore"
								class="member-list-item"
								:image="row.image"
								:name="row.name"
								:teamId="row.id"
								:isTeam="true"
								:isRightNoPadding="true"
								>

								<div class="count-wrap horizontal-center-center">
									<div>
										<div class="text-center">獲得コイン数</div>
										<div class="text-center"><span class="count">{{ row.count }}</span><span class="bold18">枚</span></div>
									</div>
								</div>
					
							</member-list-item>

							<div v-show="index < initialMaxShow || isTeamRankingRecieveMore" class="ranking-crown-wrap">
								<div class="ranking-crown text-center">
									<img :src="require('@/assets/icons/ranking_crown.svg')"/>
									<span>{{ row.rank }}</span>
								</div>
							</div>
						</div>
				
						<div class="text-center mt-20">
							<b-button type="is-more" rounded @click="isTeamRankingRecieveMore = true" v-show="!isTeamRankingRecieveMore && teamRecieveRankings.length > initialMaxShow">＋もっと見る</b-button>
						</div>
					</div>
					<div v-else style="color: #fff">データはありません</div>
				</div>

				<div v-show="isTeamRankingPresent" class="ranking present">
					<div class="ranking-title-pc text-center">贈呈</div>

					<div class="period text-center mb-15">{{ teamPeriodText }}</div>

					<div v-if="teamPresentRankings.length > 0">
						<div class="mb-10 member-list-item-wrap" v-for="(row, index) in teamPresentRankings" :key="index">
							<member-list-item
								v-show="index < initialMaxShow || isTeamRankingPresentMore"
								class="member-list-item"
								:image="row.image"
								:name="row.name"
								:teamId="row.id"
								:isTeam="true"
								:isRightNoPadding="true"
								>

								<div class="count-wrap horizontal-center-center">
									<div>
										<div class="text-center">贈呈コイン数</div>
										<div class="text-center"><span class="count">{{ row.count }}</span><span class="bold18">枚</span></div>
									</div>
								</div>
					
							</member-list-item>

							<div v-show="index < initialMaxShow || isTeamRankingPresentMore" class="ranking-crown-wrap">
								<div class="ranking-crown text-center">
									<img :src="require('@/assets/icons/ranking_crown.svg')"/>
									<span>{{ row.rank }}</span>
								</div>
							</div>
						</div>
				
						<div class="text-center mt-20">
							<b-button type="is-more" rounded @click="isTeamRankingPresentMore = true" v-show="!isTeamRankingPresentMore && teamPresentRankings.length > initialMaxShow">＋もっと見る</b-button>
						</div>
					</div>
					<div v-else style="color: #fff">データはありません</div>
				</div>

			</div>

		</div>
	</div>
</template>

<script>
import moment from 'moment'
import SummaryPeriodSelect from '@/components/SummaryPeriodSelect'
import MemberListItem from '@/components/MemberListItem'

export default {
	name: 'Ranking',
	components: {
		SummaryPeriodSelect,
		MemberListItem,
	},
	data () {
		return {
			staffPeriodId: 0,
			teamPeriodId: 0,
			isTeam: false,
			staffPeriod: '',
			teamPeriod: '',
			staffCoinId: '',
			teamCoinId: '',
			coins: [],
			staffSummaryPeriodStart: moment().format('YYYY-MM'),
			staffSummaryPeriodEnd: moment().format('YYYY-MM'),
			isStaffRankingSearchLoading: false,
			teamSummaryPeriodStart: moment().format('YYYY-MM'),
			teamSummaryPeriodEnd: moment().format('YYYY-MM'),
			isTeamRankingSearchLoading: false,
			staffRecieveRankings: [],
			staffPresentRankings: [],
			teamRecieveRankings: [],
			teamPresentRankings: [],
			isStaffRankingRecieve: true,
			isStaffRankingPresent: false,
			isStaffRankingRecieveMore: false,
			isStaffRankingPresentMore: false,
			isTeamRankingRecieve: true,
			isTeamRankingPresent: false,
			isTeamRankingRecieveMore: false,
			isTeamRankingPresentMore: false,
			initialMaxShow: 10,
		}
	},
	created() {
		if (!this.$utils.isSp()) {
			this.isStaffRankingPresent = true;
			this.isTeamRankingPresent = true;
		}
	},
	computed: {
		staffPeriodText: function() {
			return `集計期間：${this.staffPeriod}（前日集計）`;
		},
		teamPeriodText: function() {
			return `集計期間：${this.teamPeriod}（前日集計）`;
		},
		dateProvided: function() {
			return moment().format('YYYY-MM-DD');
		},
		isMemberTabUnderlineVisible: function() {
			return this.isTeam ? 'hidden' : 'visible';
		},
		isTeamTabUnderlineVisible: function() {
			return this.isTeam ? 'visible' : 'hidden';
		},
	},
	mounted() {
		this.init();
		//setTimeout(function() {
		//	window.scrollBy(0, 3000);
		//},1000);
	},
	methods: {
		onTeamRankingSearchButtonClick: function() {
			this.searchTeam(this.teamCoinId, this.teamPeriodId, this.teamSummaryPeriodStart, this.teamSummaryPeriodEnd);
		},
		searchTeam: async function(coinId, period, start, end, callback) {
			this.isTeamRankingSearchLoading = true;
			let ep = `rankings/team?coin_id=${coinId}&period=${period}&start=${start}&end=${end}`;
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.isTeamRankingRecieveMore = false;
				this.isTeamRankingPresentMore = false;
				this.teamRecieveRankings = res.data.team_recieve_rankings;
				this.teamPresentRankings = res.data.team_present_rankings;
				this.teamPeriod = res.data.period;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isTeamRankingSearchLoading = false;
			}
		},
		onTeamSummaryPeriodChange: function(periodId) {
			this.teamPeriodId = periodId;
		},
		onTeamSummaryPeriodStartChange: function(date) {
			this.teamSummaryPeriodStart = date;
		},
		onTeamSummaryPeriodEndChange: function(date) {
			this.teamSummaryPeriodEnd = date;
		},
		onStaffRankingSearchButtonClick: function() {
			this.searchStaff(this.staffCoinId, this.staffPeriodId, this.staffSummaryPeriodStart, this.staffSummaryPeriodEnd);
		},
		searchStaff: async function(coinId, period, start, end, callback) {
			this.isStaffRankingSearchLoading = true;
			let ep = `rankings/staff?coin_id=${coinId}&period=${period}&start=${start}&end=${end}`;
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.isStaffRankingRecieveMore = false;
				this.isStaffRankingPresentMore = false;
				this.staffRecieveRankings = res.data.staff_recieve_rankings;
				this.staffPresentRankings = res.data.staff_present_rankings;
				this.staffPeriod = res.data.period;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isStaffRankingSearchLoading = false;
			}
		},
		onStaffSummaryPeriodChange: function(periodId) {
			this.staffPeriodId = periodId;
		},
		onStaffSummaryPeriodStartChange: function(date) {
			this.staffSummaryPeriodStart = date;
		},
		onStaffSummaryPeriodEndChange: function(date) {
			this.staffSummaryPeriodEnd = date;
		},
		init: function() {
			this.getData();
		},
		getData: async function() {
			let loader = this.$buefy.loading.open();
			let ep = 'rankings/screen';
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.coins = res.data.coins;
				this.staffRecieveRankings = res.data.staff_recieve_rankings;
				this.staffPresentRankings = res.data.staff_present_rankings;
				this.teamRecieveRankings = res.data.team_recieve_rankings;
				this.teamPresentRankings = res.data.team_present_rankings;
				this.staffPeriod = res.data.period;
				this.teamPeriod = res.data.period;
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loader.close();
			}
		},
	}
}
</script>

<style lang="scss" scoped>
@import '@/scss/_vars.scss';

.ranking-wrap {
	margin-bottom: -50px;
	.ranking {
		padding: 30px 5px;

		.is-more {
			background: none;
			color: #fff;
			border: 2px #fff solid;
		}

		.member-list-item-wrap {
			position: relative;

			.ranking-crown-wrap {
				position: absolute;
				top: 0;
				left: 37px;

				.ranking-crown {
					position: relative;
					width: 22px;
					height: 15px;
					color: $brown;
					font-size: 10px;
					font-weight: bold;

					span {
						position: absolute;
						top: 2px;
						left: 0;
						right: 0;
						bottom: 0;
						margin: auto;
					}
				}
			}

			.count-wrap {
				width: 106px;
				height: 71px;
				background-color: rgba(242, 138, 153, .1);

				.count {
					font-size: 26px;
					font-weight: bold;
					color: $red;
					margin-right: 5px;
				}
			}
		}

		.period {
			color: #fff;
		}
	}
}

.tab-header,
.ranking-wrap {
	margin-left: -$basePadding;
	margin-right: -$basePadding;

	.ranking-title-pc {
		display: none;
	}
}

.recieve {
	background: $tabPink;
}
.present {
	background: $tabGreen;
}


.tab-header {
	color: #fff;

	.recieve,
	.present {
		border-radius: 15px 15px 0 0;
		width: 50%;
		padding: 4px 0;
		cursor: pointer;
	}
	.recieve {
	}
	.present {
	}

}

@media screen and (min-width: $breakPoint) {
	.tab-header {
		display: none;
	}

	.ranking-wrap {
		display: flex;
		justify-content: space-between;

		.ranking {
			width: 622px;
			padding-left: 50px;
			padding-right: 50px;
			border-radius: 10px;

			.ranking-title-pc {
				display: block;
				font-size: 26px;
				font-weight: bold;
				color: #fff;
				margin-bottom: 20px;
			}
		}
	}
}
</style>
